import React, { useState, useRef, useEffect } from "react";
import Bredcrum from "../../components/bredcrum";
import { Toast } from "primereact/toast";
import { saleServices } from "../../services/saleServices";
import { productservices } from "../../services/productServices";
import { AlertServices } from "../../services/alertServices";
import { Submissionbtn } from "../../components/buttons";

import { Titlebar, Searchbox, Label } from "../../components/fieldsComp";
import { Formik, Field, Form } from "formik";

import { useSelector } from 'react-redux';
import {HandleClose} from '../../helpers/formclose';

function AddAlert() {
  const toast = useRef(null);

  const [productlist, setProductlist] = useState([]);
  const unitreducer = useSelector((state)=>state.unitreducer);
  const [componentytpe, setComponenttype] = useState("product");
  const [components, setComponents] = useState([]);
  const [units,setUnits] = useState([]);
  const [products, setProducts] = useState([]);
  const [submitted,setSubmitted] = useState(true);
  const [formData, setFormData] = useState({
    alert_type: "",
    product_component_name: "",
    alert_date: "",
    stock_level: "",
    action_needed: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    getunits();
    getproduct();
    getbulkproduct();
    getcomponents();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    AlertServices.createalert(formData).then((response) => {
      if (response.status == 200) {
        setFormData(formData);
        toast.current.show({ severity: 'success', summary: 'AlertServices', detail: 'Alert added successfully' });
      } else {
        toast.current.show({ severity: 'error', summary: 'AlertServices', detail: 'Not added' });
      }
    }).catch((error) => {
      toast.current.show({ severity: 'error', summary: 'AlertServices', detail: 'Not added' });
    });
    console.log(formData); // You can send this to your API
  };

  const handleClose = () => {
    setFormData({
      order_id: "",
      sales_channel: "",
      product_sold: "",
      units_sold: "",
      sku_code: "",
      sales_price: "",
      freight_charges: "",
      royalties: "",
      stock_reduction: "",
      order_status: "",
    });
  }

  const getproduct = () => {
    productservices.getproductcomponent().then((response) => {
      console.warn(response);
      setProductlist(response.data.data);
    }).catch((error) => {

    });
  }
  function displayproduct() {
    let productdata = [];
    productlist.forEach((value, index) => {
      productdata.push(<option value={value.name + '|?|' + value.sku_code}>{value.name + ' - ' + value.sku_code}</option>);
    });

    return productdata;
  }

  useEffect(()=>{
     setComponenttype(formData.product_type);
  },[formData.product_type])


  function Componenttype(stocktype) {
    let component = <></>;
    let componentsdesign = [];
    components.forEach((value, index) => {
      componentsdesign.push(
        <option value={value.componentSkuCode}>{value.component}</option>
      );
    });

    let productsdesign = [];
    products.forEach((value, index) => {
      productsdesign.push(
        <option value={value.sku_code}>{value.product_name}</option>
      );
    });

    if (stocktype == "component") {
      component = (
        <Field
          as="select"
          name="component_skucode"
          className="form-control"
          placeholder="Select Component"
          required
        >
          <option value="">Select Component</option>
          {componentsdesign}
        </Field>
      );
    } else {
      component = (
        <Field
          as="select"
          name="product_skucode"
          className="form-control"
          placeholder="Select Product"
          required
        >
          <option value="">Select Product</option>
          {productsdesign}
        </Field>
      );
    }

    return component;
  }


  const getbulkproduct = () => {
    productservices
      .getbulkproduct()
      .then((response) => {
        if (response.status == 200) {
          setProducts(response.data.data);
        } else {
          setProducts([]);
        }
      })
      .catch((error) => {
        setProducts([]);
      });
  };

  const getcomponents = () => {
    productservices
      .getcomponents()
      .then((response) => {
        if (response.status == 200) {
          setComponents(response.data.data);
        } else {
          setComponents([]);
        }
      })
      .catch((error) => {
        setComponents([]);
      });
  };

  const handleSave  = (values) => {
    //  console.log("handle save");
    //  console.log(values); 
    //  return;
     setSubmitted(false);
     AlertServices.createalert(values).then((response)=>{
         if(response.status == 200){
             setSubmitted(true);
             toast.current.show({ severity: 'success', summary: 'Alerts and Remainder', detail: `${response.data.data}` }); 
         }else{
             setSubmitted(true);
             toast.current.show({ severity: 'error', summary: 'Alerts and Remainder', detail: `${response.data.data}` }); 
         }
     }).catch(()=>{
         setSubmitted(true);
         toast.current.show({ severity: 'error', summary: 'Alerts and Remainder', detail: `error` }); 
     })
  }

  const getunits = () =>{
    unitreducer.then((response)=>{
        //  console.log(response);
         setUnits(response);
      }).catch((error)=>{
          
      });
  }

  function displayUnits(){
    let unitsarr = [];
    units.forEach((value,index)=>{
      unitsarr.push(<option value={value.short_code}>{value.name}</option>); 
    });

    return unitsarr;
  }

  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={"add Alart & Reminders"} divider={false} />
      <div class="row">
        {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}

        {/* <Titlebar text={"Add Alerts & Reminders"} /> */}
        <div className="col-md-12 mt-3">
          <div className="card ps-3 pe-3">
            <div className="card-body card-body-style">
              <div className="row">
                <div className="container mt-4">
                  <Formik
                    initialValues={{
                      alert_type:'',
                      product_type:componentytpe
                    }}
                    onSubmit={async (values) => {
                      // console.log("values data");
                      // console.log(values);
                      handleSave(values);
                    }}
                  >
                    {({ handleChange, setFieldValue,values }) => (
                      <Form>
                        <div className="row">
                          {/* Name */}
                          <div className="col-md-6 form-group">
                             <Label name="Alert Type" />
                              <Field
                                  as="select"
                                 name="alert_type"
                                  className="form-control"
                                  placeholder="Stock Type"
                              >
                                  <option value="">Select Alert Type</option>
                                  <option value="low_stock">Low Stock</option>
                                  <option value="out_of_stock">Out of Stock</option>
                                  <option value="expiry">Expiry</option>
                                 <option value="discrepancy">Discrepancy</option>
                              </Field>
                          </div>


                          <div className="col-md-6 form-group">
                            <Label name="Product Type" />
                            <Field
                                 as="select"
                                 name="product_type"
                                  className="form-control"
                                  placeholder="Product Type"
                                   onChange={(e) => {
                                        setFormData({product_type:e.target.value});
                                        setFieldValue("product_type", e.target.value); // Update Formik state
                                    }}
                              >
                                  <option value="">Select Product Type</option>
                                  <option value="product">Product</option>
                                  <option value="component">Component</option>
                              </Field>
                          </div>

                          {/* Email */}
                          <div className="col-md-6 form-group">
                            <Label name="Select Product" />
                              {Componenttype(componentytpe)}
                          </div>
                         

                          {/* Phone */}

                          {/* Type */}
                          <div className="col-md-6 form-group">
                            <label>LowStock threshold</label>
                            <div className="flex-box">
                                <Field as="select"
                                  style={{width:'80px'}}
                                  name="low_stock_unit"
                                  className="form-control"
                                   onChange={(e) => {
                                      const { value } = e.target;
                                      setFieldValue('low_stock_unit', value);
                                      setFieldValue('over_stock_unit', value);
                                      
                                    }} 
                                  >
                                 {displayUnits()}
                                
                                </Field>
                                <Field
                                  type="number"
                                  name="low_stock_threshold"
                                  className="form-control"
                                  // value={formData.low_stock_threshold}
                                  // onChange={handleChange}
                                  placeholder="Enter no of threshold Units"
                                />  
                            </div>
                            
                          </div>

                          <div className="col-md-6 form-group">
                            <label>OverStock threshold</label>
                             <div className="flex-box">
                                <Field as="select"
                                  style={{width:'80px'}}
                                  name="over_stock_unit"
                                  className="form-control"
                                    //  onChange={(e) => {
                                    //   const { value } = e.target;
                                    //   setFieldValue('over_stock_unit', value);
                                    // }}
                                  >
                                 {displayUnits()}
                                </Field>          
                                    
                                <Field
                                  type="number"
                                  name="over_stock_threshold"
                                  className="form-control"
                                  // value={formData.low_stock_threshold}
                                  // onChange={handleChange}
                                  placeholder="Enter no of Overstock threshold Units"
                                />
                            </div>
                          </div>

                          <div className="col-md-6 form-group">
                             <Label name="Is Active" />
                              <Field
                                  as="select"
                                  name="is_active"
                                  className="form-control"
                                  // placeholder="Stock Type"
                              >
                                  <option value="">Select Active Status</option>
                                  <option value="1">Active</option>
                                 <option value="0">InActive</option>
                              </Field>
                          </div>
                          <div className="col-md-6 form-group">
                            <label>Remainder Frequency</label>
                            <Field
                              type="number"
                              name="remind_after_days"
                              className="form-control"
                              // value={formData.low_stock_threshold}
                              // onChange={handleChange}
                              placeholder="Enter days"
                            />
                          </div>
                        </div>

                        <br></br>
                       
                        <div className="row">
                          <div className='col-md-6'>
                            <Submissionbtn issaved={submitted} label={'Save'} label2={'Saving'}/>
                            {/* <button
                              type="submit"
                              className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
                            >
                              Save
                            </button> */}
                          </div>

                          {<HandleClose/>}
                        </div>
                      </Form>)}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddAlert;
